module.exports = __webpack_public_path__ + "static/machine03-e834e5da7d40ac7b8c62b99bd6b9e285.png";